import React from 'react';
import './OfflineMessage.css';

const OfflineMsg = () => (
    <div className='offline-msg'>
        <div id='offline' >
            <img alt="offline-message" src={require('../../media/images/icons/offline.svg')} />
            <h1>אופס!</h1>
            <h2> משהו השתבש עם חיבור האינטרנט שלך. </h2>
            <h2> אנא בדוק אותו ותחזור מאוחר יותר.</h2>
        </div>
    </div>
);

export default OfflineMsg;
